 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"i18n.af","3":"i18n.ar","4":"i18n.az","5":"i18n.be_BY","6":"i18n.bg","7":"i18n.bs","8":"i18n.ca","9":"i18n.cs","10":"i18n.cy","11":"i18n.da","12":"i18n.de","13":"i18n.de_AT","14":"i18n.default","15":"i18n.el","16":"i18n.en","17":"i18n.eo","18":"i18n.es","19":"i18n.et","20":"i18n.eu","21":"i18n.fa","22":"i18n.fi","23":"i18n.fr","24":"i18n.he","25":"i18n.hr","26":"i18n.hu","27":"i18n.id","28":"i18n.it","29":"i18n.ja","30":"i18n.km","31":"i18n.ko","32":"i18n.ku","33":"i18n.lo","34":"i18n.lt","35":"i18n.lv","36":"i18n.mn","37":"i18n.ms_MY","38":"i18n.nl","39":"i18n.no","40":"i18n.pl","41":"i18n.pt","42":"i18n.pt_BR","43":"i18n.ro","44":"i18n.ru","45":"i18n.sk_SK","46":"i18n.sl_SI","47":"i18n.sq","48":"i18n.sr","49":"i18n.sv","50":"i18n.ta_IN","51":"i18n.th_TH","52":"i18n.tr","53":"i18n.ug","54":"i18n.uk","55":"i18n.vi_VN","56":"i18n.zh","57":"i18n.zh_HK","58":"i18n.zh_TW"}[chunkId]||chunkId) + ".chunk." + {"0":"85c58","2":"e8085","3":"b2a6a","4":"29663","5":"58eee","6":"64443","7":"3f802","8":"d1cd1","9":"430a4","10":"ab08a","11":"5339b","12":"bed26","13":"653f8","14":"80755","15":"2eb33","16":"90113","17":"d89d6","18":"1b4f5","19":"566c3","20":"48b6a","21":"12867","22":"fbc7c","23":"a9648","24":"892e4","25":"a50c6","26":"b64f5","27":"cc8c3","28":"50b86","29":"6c68a","30":"ac5ef","31":"39b17","32":"30dd4","33":"e48c0","34":"88795","35":"8d1cd","36":"f81c0","37":"d9f52","38":"af387","39":"4b7cd","40":"4abb3","41":"ca432","42":"3da50","43":"f658e","44":"f119d","45":"ab764","46":"4b995","47":"cbac5","48":"a0d1f","49":"4fd85","50":"0cfe9","51":"c7fef","52":"fa025","53":"c9bcd","54":"5a845","55":"66a72","56":"2d782","57":"d0854","58":"9056b","61":"6f420","62":"9574f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"61":1,"62":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"i18n.af","3":"i18n.ar","4":"i18n.az","5":"i18n.be_BY","6":"i18n.bg","7":"i18n.bs","8":"i18n.ca","9":"i18n.cs","10":"i18n.cy","11":"i18n.da","12":"i18n.de","13":"i18n.de_AT","14":"i18n.default","15":"i18n.el","16":"i18n.en","17":"i18n.eo","18":"i18n.es","19":"i18n.et","20":"i18n.eu","21":"i18n.fa","22":"i18n.fi","23":"i18n.fr","24":"i18n.he","25":"i18n.hr","26":"i18n.hu","27":"i18n.id","28":"i18n.it","29":"i18n.ja","30":"i18n.km","31":"i18n.ko","32":"i18n.ku","33":"i18n.lo","34":"i18n.lt","35":"i18n.lv","36":"i18n.mn","37":"i18n.ms_MY","38":"i18n.nl","39":"i18n.no","40":"i18n.pl","41":"i18n.pt","42":"i18n.pt_BR","43":"i18n.ro","44":"i18n.ru","45":"i18n.sk_SK","46":"i18n.sl_SI","47":"i18n.sq","48":"i18n.sr","49":"i18n.sv","50":"i18n.ta_IN","51":"i18n.th_TH","52":"i18n.tr","53":"i18n.ug","54":"i18n.uk","55":"i18n.vi_VN","56":"i18n.zh","57":"i18n.zh_HK","58":"i18n.zh_TW"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","2":"31d6c","3":"31d6c","4":"31d6c","5":"31d6c","6":"31d6c","7":"31d6c","8":"31d6c","9":"31d6c","10":"31d6c","11":"31d6c","12":"31d6c","13":"31d6c","14":"31d6c","15":"31d6c","16":"31d6c","17":"31d6c","18":"31d6c","19":"31d6c","20":"31d6c","21":"31d6c","22":"31d6c","23":"31d6c","24":"31d6c","25":"31d6c","26":"31d6c","27":"31d6c","28":"31d6c","29":"31d6c","30":"31d6c","31":"31d6c","32":"31d6c","33":"31d6c","34":"31d6c","35":"31d6c","36":"31d6c","37":"31d6c","38":"31d6c","39":"31d6c","40":"31d6c","41":"31d6c","42":"31d6c","43":"31d6c","44":"31d6c","45":"31d6c","46":"31d6c","47":"31d6c","48":"31d6c","49":"31d6c","50":"31d6c","51":"31d6c","52":"31d6c","53":"31d6c","54":"31d6c","55":"31d6c","56":"31d6c","57":"31d6c","58":"31d6c","61":"a8a84","62":"d6b24"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "livechat/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([182,60]);
 	// run deferred modules when ready
 	return checkDeferredModules();
